import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="mx-auto flex max-w-3xl flex-col items-center px-5 py-32 text-center">
      <span className="font-display text-7xl font-extrabold text-brand">404</span>
      <h1 className="mt-4 font-display text-2xl font-bold text-navy">Page not found</h1>
      <p className="mt-3 text-muted-foreground">The page you're looking for has taxied to another gate.</p>
      <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-aero px-6 py-3 text-sm font-semibold text-white">
        <Home className="h-4 w-4" /> Back home
      </Link>
    </div>
  );
}
